// extracted by mini-css-extract-plugin
export default {"privacy-consent-text":"app_privacy-consent-text__R0bCT","privacy-policy-link":"app_privacy-policy-link__tknFq"};